import landingpage from "../img/landingpage.jpg";
import form from "../img/form.jpg";
import crud from "../img/crud.jpg";

export const projectsList = [
  {
    id: 1,
    title: "Landing Page",
    img: `${landingpage}`,
    link: "https://markopersonally.github.io/firstlandingpage/",
  },
  {
    id: 2,
    title: "Validation form",
    img: `${form}`,
    link: "https://validation-form-snowy.vercel.app/",
  },
  {
    id: 3,
    title: "Crud App",
    img: `${crud}`,
    link: "https://crud-app-pi-six.vercel.app/",
  },
];
